import baseApi, {
    transformResponseFromData,
    provideTag,
} from 'store/slices/api/baseApi'
import {constructUrl} from './utils'

const sessionsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSessions: build.query({
            query: (query) => {
                const url = constructUrl('sessions', {
                    ...query,
                    sort: query.sort ?? JSON.stringify({created: 'desc'}),
                })
                return {
                    url,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            providesTags: () => provideTag('Session'),
        }),
        getSession: build.query({
            query: (id) => ({
                url: `sessions/${id}`,
                method: 'GET',
            }),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTag('Session', result),
        }),
        createSession: build.mutation({
            query: (body) => {
                return {
                    url: `sessions`,
                    method: 'POST',
                    body,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('Session'),
        }),
        saveSession: build.mutation({
            query: (body) => {
                return {
                    url: `sessions/${body._id}`,
                    method: 'PUT',
                    body,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) => provideTag('Session', result),
        }),
        deleteSession: build.mutation({
            query: (id) => {
                return {
                    url: `sessions/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('Session'),
        }),
        reorderLearnedDances: build.mutation({
            query: ({sessionId, danceIds}) => {
                return {
                    url: `sessions/${sessionId}/learnedDances/reorder`,
                    method: 'PUT',
                    body: {danceIds},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('Session'),
        }),
        deleteLearnedDance: build.mutation({
            query: ({sessionId, danceId}) => {
                return {
                    url: `sessions/${sessionId}/learnedDances/${danceId}`,
                    method: 'DELETE',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('Session'),
        }),
    }),
    overrideExisting: false,
})

export default sessionsApi

export const {
    useGetSessionsQuery,
    useGetSessionQuery,
    useCreateSessionMutation,
    useSaveSessionMutation,
    useDeleteSessionMutation,
    useReorderLearnedDancesMutation,
    useDeleteLearnedDanceMutation,
} = sessionsApi
